import { Fragment, useEffect, useState } from "react";
import SectionTitle from "../section-title/section-title.component";
import { Col, Form, Row } from "react-bootstrap";
import { netural400, neturalBlack } from "../../constants/color";
import FormFooterButtons from "../form-footer-buttons/form-footer-buttons.component";
import IllustrationImage from "../shared/illustration-image/illustration-image.component";
import AddressSelection from "../address-selection/address-selection.component";
import {
  ADD_PICKUP_ADDRESS,
  EDIT_PICKUP_ADDRESS,
  FETCH_COUNTRY_FOR_PICKUP,
  FETCH_PICKUP_ADDRESS,
} from "../../services/graphql/businessAccount";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useLazyQuery, useMutation } from "@apollo/client";
import LoadingSpinner from "../shared/loading-spinner/loading-spinner.component";

const ProductSellQuestion = ({
  handleBackClick,
  handleNextClick,
  setProductSellQuestion,
  formValue,
}) => {
  const [isErrorMessage, setIsErrorMessage] = useState({
    sellingError: "",
    addressError: "",
  });
  const businesprofile = useSelector((state) => state.businesprofile);
  const [selectedOption, setSelectedOption] = useState(""); // Store selected option
  const [showAddressInput, setShowAddressInput] = useState(false); // Show input field
  const [newAddress, setNewAddress] = useState({
    address: "",
    lat: 0.0,
    lng: 0.0,
  }); // Store new address input
  const [addressList, setAddressList] = useState([]); // Store list of addresses
  const [selectedAddress, setSelectedAddress] = useState({}); // Store selected address
  const [editIndex, setEditIndex] = useState(null); // Track index of address being edited
  const [countryCode, setCountryCode] = useState(["us", "ca"]);

  useEffect(() => {
    if (formValue.productSellQuestion) {
      setSelectedOption(formValue.productSellQuestion);
      setSelectedAddress(formValue.productPickupAddress);
    }
    fetchPickupAddress();
    fetchCountryForPickup();
  }, [formValue]);

  const handleChange = (option) => {
    if (option === "Delivery") {
      setSelectedAddress({});
    }
    setSelectedOption(option);
    setShowAddressInput(false);
  };

  // Add new address button
  const handleAddNewAddress = () => {
    setShowAddressInput(true);
    setEditIndex(null); // Reset edit mode
    setNewAddress(""); // Clear input
  };

  // Store or update address
  const handleNext = () => {
    if (newAddress.address.trim() !== "") {
      if (editIndex !== null) {
        // Update existing address
        // const updatedList = [...addressList];
        // updatedList[editIndex] = newAddress;
        // setAddressList(updatedList);
        setSelectedAddress(newAddress); // Auto-select edited address
        // setEditIndex(null);
        updatePickupAddress();
      } else {
        // Add new address (max 2)
        if (addressList.length < 2) {
          // const updatedAddresses = [...addressList, newAddress];
          // setAddressList(updatedAddresses);
          console.log("Address------------", newAddress);
          setSelectedAddress(newAddress); // Auto-select new address
          addPickupAddress(newAddress);
        }
      }
      setNewAddress("");
      setShowAddressInput(false);
    }
  };

  const addPickupAddress = async (newAddress) => {
    // console.log("Address-----", newAddress);
    await createProduct({
      variables: {
        businessId: businesprofile._id,
        address: {
          address: newAddress.address,
          lat: newAddress.lat,
          lng: newAddress.lng,
        },
      },
    });
  };

  const updatePickupAddress = async () => {
    // console.log(
    //   "Address index---------",
    //   editIndex,
    //   newAddress,
    //   addressList[editIndex]
    // );
    await editPickupAddress({
      variables: {
        businessId: businesprofile._id,
        addressId: addressList[editIndex]._id,
        address: {
          address: newAddress.address,
          lat: newAddress.lat,
          lng: newAddress.lng,
        },
      },
    });
  };

  const fetchPickupAddress = async () => {
    await fetchPickupAddresses({
      variables: {
        businessId: businesprofile._id,
      },
    });
  };

  const [createProduct, { loading: loadingCreatePickAddress }] = useMutation(
    ADD_PICKUP_ADDRESS,
    {
      onCompleted: (data) => {
        // console.log("Responsive----------", data.addPickupAddress);
        if (data && data.addPickupAddress) {
          const newAddress = data.addPickupAddress;
          const updatedAddresses = [...addressList, newAddress];
          setAddressList(updatedAddresses);
          setSelectedAddress(newAddress);
          toast.success("Address added successfully!", {
            style: { width: "450px" },
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored ",
          });
        } else {
          console.log(data.addPickupAddress, "ERROR==============");
        }
      },
      onError: (error) => {
        console.log(error, "ERROR==============");
        toast.error(error.message, {
          style: { width: "450px" },
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored ",
        });
      },
    }
  );

  const [fetchPickupAddresses, { loading: loadingPickAddress }] = useLazyQuery(
    FETCH_PICKUP_ADDRESS,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: true,
      onError: (error) => {
        console.log(error, "ERROR==============");
        toast.error(error.message, {
          style: { width: "450px" },
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored ",
        });
      },
      onCompleted: (data) => {
        if (data && data.fetchPickupAddresses) {
          const pickupAddress = data.fetchPickupAddresses;
          // console.log("all value------------", pickupAddress, pickupAddress[0]);
          if (pickupAddress.length !== 0) {
            setAddressList(pickupAddress);
            if (pickupAddress.length === 1 && selectedAddress !== "") {
              setSelectedAddress(pickupAddress[0]);
            }
          }
        }
      },
    }
  );

  const [fetchCountryForPickup] = useMutation(FETCH_COUNTRY_FOR_PICKUP, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: true,
    onCompleted: (data) => {
      if (data && data.fetchCountryForPickup) {
        const countryCode = data.fetchCountryForPickup;
        setCountryCode(countryCode);
      }
    },
  });

  const [editPickupAddress, { loading: loadingEditPickAddress }] = useMutation(
    EDIT_PICKUP_ADDRESS,
    {
      onCompleted: (data) => {
        if (data && data.editPickupAddress) {
          const newAddress = data.editPickupAddress.updatedAddress;
          const updatedList = [...addressList];
          updatedList[editIndex] = newAddress;
          // console.log(
          //   "Edit Responsive----------",
          //   newAddress.address,
          //   updatedList
          // );
          setAddressList(updatedList);
          setSelectedAddress(newAddress.address);
          toast.success("Address updated successfully!", {
            style: { width: "450px" },
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored ",
          });
        } else {
          console.log(data.addPickupAddress, "ERROR==============");
        }
      },
      onError: (error) => {
        console.log(error, "ERROR==============");
        toast.error(error.message, {
          style: { width: "450px" },
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored ",
        });
      },
    }
  );

  // Handle address selection
  const handleAddressSelect = (address) => {
    setSelectedAddress(address);
  };

  // Edit an address
  const handleEditAddress = (index) => {
    // console.log("edit index--------", index, addressList[index]);
    setEditIndex(index);
    setNewAddress(addressList[index]);
    setShowAddressInput(true);
  };

  // Handle address input change
  const handleAddressChange = (address, lat = 0.0, lng = 0.0) => {
    setNewAddress({
      address,
      lat,
      lng,
    });
  };

  const handleSubmit = () => {
    if (selectedOption === "") {
      setIsErrorMessage({
        sellingError: "Please select any one option!",
      });
    } else if (
      (selectedOption === "Pick-Up and Delivery" ||
        selectedOption === "Pick-Up") &&
      Object.keys(selectedAddress).length === 0
    ) {
      setIsErrorMessage({
        sellingError: "Please select any one pickup address!",
      });
    } else {
      setProductSellQuestion(selectedOption, selectedAddress);
      handleNextClick();
    }
  };

  return (
    <Fragment>
      <div style={{ marginTop: "5%", marginBottom: "3%" }}>
        <SectionTitle
          title={"How would you like to sell this product?"}
          subtitle={"Choose option that better suits you."}
        />
      </div>
      <Form noValidate>
        <Row className="mb-3" style={{ marginLeft: "10%" }}>
          <Col md="6" lg="6" style={{ marginLeft: "3%" }}>
            <div className="mb-3" style={{ display: "grid" }}>
              <div
                style={{ display: "flex", alignItems: "center" }}
                onClick={() => handleChange("Pick-Up")}
              >
                <Form.Check
                  inline
                  label=""
                  name="group1"
                  type="radio"
                  id="pickup"
                  style={{ fontSize: "18px" }}
                  checked={selectedOption === "Pick-Up"}
                  onChange={() => handleChange("Pick-Up")}
                />
                <div style={{ display: "grid" }}>
                  <label style={{ fontSize: "18px", color: neturalBlack }}>
                    Pick-Up
                  </label>
                  <label style={{ fontSize: "16px", color: netural400 }}>
                    Convenient in-store or on-site collection.
                  </label>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  marginTop: "3%",
                  alignItems: "center",
                }}
                onClick={() => handleChange("Delivery")}
              >
                <Form.Check
                  inline
                  label=""
                  name="group1"
                  type="radio"
                  id="delivery"
                  style={{ fontSize: "18px" }}
                  checked={selectedOption === "Delivery"}
                  onChange={() => handleChange("Delivery")}
                />
                <div style={{ display: "grid" }}>
                  <label style={{ fontSize: "18px", color: neturalBlack }}>
                    Delivery
                  </label>
                  <label style={{ fontSize: "16px", color: netural400 }}>
                    Get products delivered to your customers.
                  </label>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  marginTop: "3%",
                  alignItems: "center",
                }}
                onClick={() => handleChange("Pick-Up and Delivery")}
              >
                <Form.Check
                  inline
                  label=""
                  name="group1"
                  type="radio"
                  id="pickup-delivery"
                  style={{ fontSize: "18px" }}
                  checked={selectedOption === "Pick-Up and Delivery"}
                  onChange={() => handleChange("Pick-Up and Delivery")}
                />
                <div style={{ display: "grid" }}>
                  <label style={{ fontSize: "18px", color: neturalBlack }}>
                    Pick-Up and Delivery
                  </label>
                  <label style={{ fontSize: "16px", color: netural400 }}>
                    Customers will be able to select their preferred option
                    during checkout.
                  </label>
                </div>
              </div>
              {isErrorMessage && isErrorMessage.sellingError !== "" ? (
                <div
                  style={{
                    display: "flex",
                    marginTop: "3%",
                    justifyContent: "center",
                  }}
                >
                  <label style={{ fontSize: ".875em", color: "#dc3545" }}>
                    {" "}
                    {isErrorMessage.sellingError}{" "}
                  </label>
                </div>
              ) : null}
              {/* Address section */}
              {selectedOption === "Pick-Up and Delivery" ||
              selectedOption === "Pick-Up" ? (
                loadingPickAddress ||
                loadingCreatePickAddress ||
                loadingEditPickAddress ? (
                  <LoadingSpinner />
                ) : (
                  <AddressSelection
                    selectedOption={selectedOption}
                    addressList={addressList}
                    showAddressInput={showAddressInput}
                    selectedAddress={selectedAddress}
                    handleAddressSelect={handleAddressSelect}
                    handleAddNewAddress={handleAddNewAddress}
                    newAddress={newAddress}
                    setNewAddress={setNewAddress}
                    handleAddressChange={handleAddressChange}
                    handleEditAddress={handleEditAddress}
                    handleNext={handleNext}
                    editIndex={editIndex}
                    countryCode={countryCode}
                  />
                )
              ) : null}
              {/* End Address section */}
            </div>

            <FormFooterButtons
              displayPreviousButton={true}
              previousButtonText={"Back"}
              handlePreviouButtonClick={handleBackClick}
              handleNextButtonClick={handleSubmit}
              nextButtonText={"Continue"}
            />
          </Col>
          <Col
            md="5"
            lg="5"
            style={{
              justifyContent: "center",
              display: "flex",
              alignItems: "center",
            }}
          >
            <IllustrationImage />
          </Col>
        </Row>
      </Form>
    </Fragment>
  );
};

export default ProductSellQuestion;
